module.exports = __webpack_public_path__ + "static/media/drag-and-drop.aeac1be6.png";